import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var PaginationWarning = styled.div.withConfig({
  displayName: "DisabledPaginationInfostyles__PaginationWarning",
  componentId: "keen-widget-settings__sc-93grxr-0"
})(["&&&{min-height:37px;padding:10px 15px;margin-top:10px;max-width:390px;box-sizing:border-box;display:flex;align-items:center;gap:10px;background:", ";}"], colors.gray[100]);
export var IconWrapper = styled.div.withConfig({
  displayName: "DisabledPaginationInfostyles__IconWrapper",
  componentId: "keen-widget-settings__sc-93grxr-1"
})(["&&&{flex-shrink:0;display:flex;}"]);
export var TextWrapper = styled.div.withConfig({
  displayName: "DisabledPaginationInfostyles__TextWrapper",
  componentId: "keen-widget-settings__sc-93grxr-2"
})(["&&&{margin-top:1px;}"]);